import type { Ref } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { getEnv } from '../../utils/environment';

const CAPTCHA_ERROR = 'hCaptcha Error: ';
const CAPTCHA_EXPIRED = 'hCaptcha Token Expired';

type HCaptchaContainerProps = {
  onExpire?: () => void;
  onError?: (error: string) => void;
  ref?: Ref<HCaptcha>;
};

const HCaptchaContainer = ({ onExpire, onError, ref }: HCaptchaContainerProps) => {
  const handleHCaptchaExpire = () => {
    datadogLogs.logger.error(CAPTCHA_EXPIRED);
    if (onExpire) {
      onExpire();
    }
  };
  const handleHCaptchaError = (err: unknown) => {
    const error = err as Error;
    datadogLogs.logger.error(CAPTCHA_ERROR, {}, error);
    if (onError) {
      onError(err as string);
    }
  };
  const hCaptchaSiteKey =
    process.env.GATSBY_HCAPTCHA_SITEKEY ||
    process.env.REACT_APP_HCAPTCHA_SITEKEY ||
    getEnv().hCaptchaSiteKey;

  return (
    <form>
      <HCaptcha
        sitekey={hCaptchaSiteKey}
        size="invisible"
        onExpire={handleHCaptchaExpire}
        onError={handleHCaptchaError}
        ref={ref}
        id="hcaptchaWidget"
      />
    </form>
  );
};

export default HCaptchaContainer;
